import { ReactNode, VFC } from 'react'
import {
  _tooltip,
  _tooltipbg,
  _tooltipshadow,
  black,
  truewhite,
} from 'src/styles/colors'
import styled, { SimpleInterpolation, css } from 'styled-components'

type TooltipProps = TooltipStyleProps & {
  children: ReactNode
  className?: string
}
const TooltipComponent: VFC<TooltipProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <TooltipContainer className={className} {...props}>
      {children}
    </TooltipContainer>
  )
}

const Tooltip = styled(TooltipComponent)``

type TooltipType = 'scheduleUrl' | 'messageHeader'
type TooltipWrapperProps = {
  children: ReactNode
  tooltipNode: ReactNode
  tooltipStyle?: SimpleInterpolation
  direction?: TooltipStyleProps['direction']
  xValue?: TooltipStyleProps['xValue']
  yValue?: TooltipStyleProps['yValue']
  top?: number
  type?: TooltipType
  disabled?: boolean
  isWrap?: boolean
  writingMode?: string
}
export const TooltipWrapper: VFC<TooltipWrapperProps> = ({
  children,
  tooltipNode,
  tooltipStyle,
  direction,
  xValue,
  yValue,
  top,
  type,
  disabled,
  isWrap,
  writingMode = 'vertical-tb',
}) => {
  return (
    <TooltipWrapperDiv isWrap={isWrap || false}>
      {children}
      {!disabled && (
        <Tooltip
          styles={tooltipStyle}
          direction={direction}
          xValue={xValue}
          yValue={yValue}
          writingMode={writingMode}
          top={top}
          type={type}
        >
          {tooltipNode}
        </Tooltip>
      )}
    </TooltipWrapperDiv>
  )
}

const scheduleUrlCss = css`
  :after {
    content: '';
    position: absolute;
    right: 90%;
    bottom: -10px;
    border-color: #fff transparent transparent transparent;
    border-width: 10px 10px 0 10px;
  }

  box-shadow: rgb(164 164 164) 3px 6px 20px;
  padding: 16px 16px;
  color: ${black};
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 1px;
  background-color: ${truewhite};
  top: -100px;
`

const messageHeaderCss = css``

type TooltipStyleProps = {
  styles?: SimpleInterpolation
  direction?: Partial<{
    x: 'left' | 'right'
    y: 'top' | 'bottom'
  }>
  xValue?: string
  yValue?: string
  writingMode?: string
  top?: number
  type?: TooltipType
}
const TooltipContainer = styled.div<TooltipStyleProps>`
  display: inline-block;
  writing-mode: ${({ writingMode }) =>
    writingMode ? `${writingMode}` : 'vertical-lr'};
  border-radius: 5px;
  background-color: ${_tooltipbg};
  color: ${_tooltip};
  box-shadow: ${_tooltipshadow};
  z-index: 1;
  padding: 8px 16px;

  position: absolute;
  ${({ top }) => top && `top: ${top}px`};
  ${({ direction = {}, xValue = {}, yValue = {} }) =>
    `
    ${direction.x === 'left' ? 'right' : 'left'}: ${!xValue ? '100%' : xValue};
    ${direction.y === 'top' ? 'bottom' : 'top'}: ${!yValue ? '100%' : yValue};
    `};
  ${({ styles }) => styles};

  // NOTE: 共通で使わないCSSは、typeで分けて追加する
  ${({ type }) =>
    type === 'scheduleUrl'
      ? scheduleUrlCss
      : type === 'messageHeader'
      ? messageHeaderCss
      : ''}
`

const TooltipWrapperDiv = styled.div<{ isWrap: boolean }>`
  position: relative;
  white-space: ${({ isWrap }) => (isWrap ? 'pre-wrap' : 'nowrap')};
  ${Tooltip} {
    display: none;
  }
  :hover {
    ${Tooltip} {
      display: unset;
    }
  }
`
